<template>
  <div class="card-list" :class="{ 'with-background': isPurchaseCardPage }">
    <div class="card-list-container"  >
      <template v-for="(cardItem, index) in cardList">
        <div
          class="card-container"
          :key="index"
          :class="{'canceled': cardItem.status == 1}"
        >
          <!-- <div v-if="isSpecialItem(cardItem)" class="special-label">
            特価
          </div> -->
          <div class="image-area">
            <img class="card" :src="cardItem.image" :alt="cardItem.name">
            <img v-if="cardItem.name && cardItem.name.includes('PSA')" class="psa-icon" src="/img/PSA.png">
            <img v-if="cardItem.is_tokka == 1" class="psa-icon" src="/img/damaged.png">
          </div>
          <div class="info-box">
            <div class="name">{{ cardItem.name }}</div>
            <div class="rarity">{{ cardItem.rarity }}</div>
            <div class="model-number">{{ cardItem.model_number }}</div>
          </div>
          <div class="price-box">
            <span v-if="isHistory" class="price">{{ t('¥') }}{{ cardItem.price | comma }}</span>
            <span v-else class="price">{{ t('¥') }}{{ cardItem.stock_sale_price | comma }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { separateCharacterNumber } from '@/common/util/format';
import t from '@/plugins/i18n';

export default {
  name: 'PurchaseCardList',
  mixins: [t],

  props: {
    cardList: {
      type: Array,
      default: () => [],
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },
  // methods: {
  //   isSpecialItem(cardItem) {
  //     return this.isHistory && cardItem.is_tokka === 1;
  //   },
  // },
  computed: {
    isPurchaseCardPage() {
      return this.$route.name === 'PurchaseCard';
    },
  },
};
</script>

<style lang="scss" scoped>
.card-list{
  max-width: 99%;
  margin: 0 auto;
  &.with-background {
    background-image: url('/img/purchase-container.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 19px;
    margin-top: 10px;
  }
}
.card-list-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 650px;
  gap: 15px;
  margin: 0 auto;
  @media screen and (min-width: 1338px) {
    max-width: 1306px;
  }

  @media screen and (min-width: 1672px) {
    max-width: 1636px;
  }
}
.card-container {
  display: flex;
  position:relative;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 150px;
  padding-bottom: 35px;
  margin: 10px 0;
  background: white;
  border-radius: 10px;
  box-shadow:
        0 0 0 1.5px #2cbaf0,   // 内側の青い線
        0 0 0 3px #ffffe1,     // 黄色の線 (間)
        0 0 0 4.5px #2cbaf0,    // 外側の薄い青い線
        0 0 10px rgba(0, 0, 0, 0.8);
  background-image: url('/img/card_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .special-label{
    position: absolute;
    top: -25px;
    left: 0;
    background: white;
    color: #b71922;
    font-size: 16px;
    font-weight: bold;
    padding: 5px 20px;
    border-radius: 5px;
    border: 2px solid #b71922;
  }
  .image-area {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;
    position: relative;
    .card {
      width: 100%;
      border-radius: 5px;
    }
    .psa-icon{
      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 70px;
      height: auto;
    }
  }
  .info-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    text-align: center;
    padding: 10px 0;
    width: 100%;
    margin-top: -10px;
    position: relative;
    .name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: calc(1.3em * 2);
      line-height: 1.2;
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 5px;
      word-break: break-word;      // ← これ追加
      overflow-wrap: break-word;
    }
    .rarity {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: calc(1.3em * 1);
      width: fit-content;
      font-weight: bold;
      background: linear-gradient(to top, #276bad,#2d8dc5, #67bacc);
      color: white;
      min-width:70%;
      border-radius: 5px;
      font-size: 13px;
      margin-bottom: 5px;

    }
    .model-number {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: calc(1.3em * 1);
      font-weight: bold;
      font-size: 13px;
    }
  }
  .price-box {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: linear-gradient(to right, #fff1b0,#fff1b1,#ffeb99, #ffda7d); // 黄色系のグラデーション
    color: black;
    border-radius: 0 0 10px 10px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $gray2;
  }
  &.canceled {
    filter: grayscale(100%);
    opacity: 1.6;
  }
}
@media screen and (max-width: $tabletWidth) {
  .card-list-container {
    max-width: 490px;
    gap: 15px;
  }
  .card-container {
    width: 150px; // 3列レイアウト
    .image-area {
      .psa-icon{
        width: 40px;
        bottom: 4px;
      }
    }
    .info-box {
      padding: 8px 2px;
      .name{
        font-size: 11px;
      }
      .rarity{
        font-size: 11px;
      }
      .model-number{
        font-size: 11px
      }
    }
    .price-box {
      font-size: 14px;
    }
    .price{
      font-size: 16px;
    }
  }
}
@media screen and (max-width: 500px) {
  .card-container {
    padding: 0 5px 35px 5px;
    width: calc(33.333% - 10px);
    .info-box {
      padding: 4px 2px;
      .name{
        font-size: 10px;
      }
      .rarity{
        font-size: 10px;
      }
      .model-number{
        font-size: 10px;
      }
    }
    .price-box {
      font-size: 14px;
    }
    .price{
      font-size: 14px;
    }
    .price-box {
      font-size: 12px;
    }
  }
}
</style>
